import faker from 'faker';

export default Array(10)
  .fill(0)
  .map((_, index) => ({
    id: index,
    tipoDocumento: faker.lorem.words(1),
    numero: faker.random.number({ min: 1000, max: 5000 }),
    descricao: faker.lorem.words(10),
    dataVigenciaInicio: faker.date.past(10).toLocaleString(),
    dataVigenciaTermino: faker.date.future(10).toLocaleString(),
    nome: faker.lorem.words(1)
  }));
